var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 293.596,
    cy: 31.067,
    fill: "#9bcada",
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.933,
    cy: 63.2,
    fill: "#c6e0ea",
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.733,
    cy: 368.467,
    fill: "#f0f5fa",
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.333,
    cy: 448.8,
    fill: "#9bcada",
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.133,
    cy: 191.733,
    fill: "#f0f5fa",
    r: 15
  })), /*#__PURE__*/React.createElement("path", {
    d: "m497 457.9h-9.1v-9.1c0-8.284-6.716-15-15-15s-15 6.716-15 15v9.1h-9.1c-8.284 0-15 6.716-15 15s6.716 15 15 15h9.1v9.1c0 8.284 6.716 15 15 15s15-6.716 15-15v-9.1h9.1c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#c6e0ea"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.533,
    cy: 368.467,
    fill: "#00f4ff",
    rx: 143.534,
    ry: 143.533,
    transform: "matrix(.707 -.707 .707 .707 -218.505 209.415)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.6,
    cy: 207.8,
    fill: "#ff6378",
    r: 111.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.567,
    cy: 71.233,
    fill: "#ffb428",
    rx: 71.233,
    ry: 71.233,
    transform: "matrix(.924 -.383 .383 .924 -15.723 63.424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.533 224.933v287.067c79.145 0 143.534-64.389 143.534-143.533s-64.389-143.534-143.534-143.534z",
    fill: "#00b4fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.067 368.467c0-79.145-64.389-143.534-143.534-143.534-61.844 0-114.678 39.316-134.822 94.267h150.889c9.447 0 17.133 7.686 17.133 17.133 0 9.599-7.775 17.133-17.133 17.133h-32.133c-25.487 0-47.133 20.553-47.133 47.133 0 25.989 21.144 47.133 47.133 47.133h135.665c15.114-22.727 23.935-49.984 23.935-79.265z",
    fill: "#00b4fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.067 368.467c0-79.145-64.389-143.534-143.534-143.534v94.267h16.067c9.447 0 17.133 7.686 17.133 17.133 0 9.599-7.775 17.133-17.133 17.133h-16.067v94.267h119.599c15.114-22.728 23.935-49.985 23.935-79.266z",
    fill: "#0073f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.6 319.2v-222.8c61.426 0 111.4 49.974 111.4 111.4s-49.974 111.4-111.4 111.4z",
    fill: "#d000b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.667 224.933h-126.149c1.637 10.561 4.768 20.632 9.16 30h116.988c8.284 0 15-6.716 15-15s-6.715-15-14.999-15z",
    fill: "#d000b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.522 160.667h-116.989c-8.284 0-15 6.716-15 15s6.716 15 15 15h126.149c-1.637-10.561-4.768-20.633-9.16-30z",
    fill: "#d000b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.667 239.933c0-8.284-6.716-15-15-15h-16.067v30h16.066c8.285 0 15.001-6.716 15.001-15z",
    fill: "#9330a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.058 187.07c-.042-.224-.085-.448-.129-.671-.476-2.434-1.029-4.84-1.661-7.214-.038-.144-.078-.287-.117-.431-.319-1.18-.654-2.354-1.011-3.518-.002-.007-.004-.014-.006-.022-.767-2.5-1.62-4.962-2.554-7.384-.002-.005-.003-.009-.005-.013-.936-2.425-1.955-4.809-3.052-7.149h-100.923v30h110.082c-.187-1.208-.399-2.405-.624-3.598z",
    fill: "#9330a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.8 71.233c0-39.278-31.955-71.233-71.233-71.233v142.467c39.278 0 71.233-31.955 71.233-71.234z",
    fill: "#ff8c00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanets);
export default __webpack_public_path__ + "static/media/planets.b2a1bd0be5751a7b23dd87788ede2eff.svg";
export { ForwardRef as ReactComponent };